import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import style from './style.less';
import styleSimple from './style-simple.less';
import styleCrazy from './style-crazy.less';
import tpl from './dom.html';
import TabsPane from '../common/TabsPane/script';

const { createUniqueId, isFunction, isArray } = common;
const { $id } = dom;

const TabMC = 'b_waimai_gyuaz9hn_mc';

const sticky150 = style['sticky-on-top150'];
const sticky0 = style['sticky-on-top0'];
const sticky180 = style['sticky-on-top180'];

const getTabContainerID = (key) => `tabs_container_${key}`;

/**
 * 标签页
 * @param {object} props 标签页参数
 * @param {string} props.defaultActiveTabKey 默认选中的标签的key
 * @param {array} props.tabInfo 标签信息，格式为[{key,label,innerComponent}]
 * @param {function} [props.onTabBarClick] 切换标签后的回调函数，参数为key。可以是普通函数可以是异步函数。普通函数通过返回true/false来控制是否切换标签。异步函数通过resolve(true/false)来控制是否切换标签，如果reject则不切换标签。
 * @param {boolean} [props.isSticky] 可选参数，是否启用sticky属性，默认为true,
 * @param {object} [props.oadLX] 可选参数，用于灵犀打点上报
 * @param {number} [props.stickMargin] 可选参数，Tabs加入sticky属性后距离顶部的边距，默认为0
 * @returns {string} 标签页html
 */
const Tabs = (props = {}) => {
    const {
        defaultActiveTabKey,
        tabInfo,
        onTabBarClick,
        isSticky = true,
        oadLX,
        stickMargin = 0,
        theme = 'native',
        tabNavID = createUniqueId(),
    } = props;
    const tabContentID = createUniqueId();

    let currentKey = defaultActiveTabKey;

    // 1. 必要检查参数
    if (!isArray(tabInfo)) {
        throw new Error('Tabs: tabInfo must be an array');
    }
    if (typeof defaultActiveTabKey !== 'string' || defaultActiveTabKey.length === 0) {
        throw new Error('Tabs: defaultActiveTabKey must be a non-empty string');
    }

    const data = {
        tabNavID,
        tabContentID,
        tabInfo,
        defaultActiveTabKey,
        TabsPane: (key, innerComponent, defaultDisplay) => {
            const tabContainerID = getTabContainerID(key);
            const tabsPane = TabsPane({ tabContainerID, innerComponent, defaultDisplay });
            return tabsPane;
        },
    };
    let currentStyle;
    if (theme === 'native') {
        currentStyle = style;
    } else if (theme === 'simple') {
        currentStyle = styleSimple;
    } else if (theme === 'crazy') {
        currentStyle = styleCrazy;
    } else {
        currentStyle = style;
    }
    if (isSticky) {
        if (stickMargin === 0) {
            currentStyle['sticky-on'] = sticky0;
        } else if (stickMargin === 150) {
            currentStyle['sticky-on'] = sticky150;
        } else if (stickMargin === 180) {
            currentStyle['sticky-on'] = sticky180;
        }
    }

    const events = {
        onTabBarClick: (key) => {
            if (key === currentKey) {
                return;
            }
            currentKey = key;
            const tabContainerID = getTabContainerID(key);
            // 打点上报
            if (oadLX) {
                const valLab = {
                    custom: { key },
                };
                oadLX.mc(TabMC, valLab);
            }
            // 更换Nav样式
            const tabNav = Array.from($id(data.tabNavID).children);
            tabNav.forEach((item) => {
                const currentKey = item.getAttribute('id');
                if (currentKey === key) {
                    item.children[0].classList.add(currentStyle.active);
                } else {
                    item.children[0].classList.remove(currentStyle.active);
                }
            });
            // 更换显示的组件
            const tabContent = Array.from($id(data.tabContentID).children);
            tabContent.forEach((item) => {
                const currentKey = item.getAttribute('id');
                if (currentKey === tabContainerID) {
                    item.style.display = 'block';
                } else {
                    item.style.display = 'none';
                }
            });
            // 触发回调
            if (isFunction(onTabBarClick)) {
                onTabBarClick(key);
            }
        },
    };
    const component = createComponent(tpl, { data, style: currentStyle }, events);
    return component;
};

Tabs.TabsPane = TabsPane;
Tabs.getTabContainerID = getTabContainerID;

export default Tabs;
